import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SpecialConditionsProductService } from '@account/services/special.conditions.product.service';
import { AuthService } from '@auth/auth.service';
import { CustomResponseDto } from '@core/model/custom-response-dto';
import { IdentityValidationInitialValidationDto } from '@core/model/identity-validation-initial-validation-dto';
import { MarketingEventEnumeration, MarketingEventService } from '@shared/services';
import { MESSAGE_ALGO_SALIO_MAL, TITLE_ERROR, show_popup } from '@shared/utility/popup-error';

@Component({
  selector: 'app-identity-validation',
  templateUrl: './identity-validation.component.html',
  styleUrls: ['./identity-validation.component.css'],
})
export class IdentityValidationComponent implements OnInit, OnDestroy {
  private readonly unSubscribe$: Subject<void>;
  public showLoader: boolean;

  constructor(
    private auth: AuthService,
    private specialConditionsProductService: SpecialConditionsProductService,
    private router: Router,
    private marketingEventService: MarketingEventService
  ) {
    this.showLoader = true;
    this.unSubscribe$ = new Subject();

    if (!this.isUserAutenticated()) {
      sessionStorage.removeItem('X-Request-ID');
      sessionStorage.removeItem('flow');
      sessionStorage.removeItem('email');
      sessionStorage.setItem('flow', 'origination_process');
    }
  }

  isUserAutenticated() {
    return this.auth.isAuthenticated() && !this.auth.isTokenExpired();
  }

  ngOnInit(): void {
    if (!this.isUserAutenticated()) {
      this.router.navigate(['/LoanApplicationRejected']);
      return;
    }

    this.specialConditionsProductService
      .getIsRequired()
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe({
        next: (response: CustomResponseDto<IdentityValidationInitialValidationDto>) => {
          this.marketingEventService.sendMarketingEvents(MarketingEventEnumeration.INIT_VALIDATION_IDENTITY_RP);
          this.redirectToUrl(response?.response?.urlRedirect);
        },
        error: () => {
          show_popup(TITLE_ERROR, MESSAGE_ALGO_SALIO_MAL);
          this.marketingEventService.sendMarketingEvents(MarketingEventEnumeration.FAIL_INIT_VALIDATION_IDENTITY_RP);
        },
      });
  }

  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  private redirectToUrl(url: string): void {
    url ? this.router.navigate(['/' + url]) : this.router.navigate(['/signLoanApplication']);
  }
}
